import { Formik, Form } from "formik";
import * as Yup from "yup";
import MainLayout from "../../layout";
import FormTextField from "../../components/form/text";
import { useNavigate } from "react-router-dom";
import successToast from "../../components/toast/successToast";
import errorToast from "../../components/toast/errorToast";
import { FormDropDown } from "../../components/form/dropdown";
import { FormTextAreaField } from "../../components/form/text-area";
import { useState } from "react";
import { useEffect } from "react";
import { FormMultiFileUploadField } from "../../components/form/multi-file";
import { api } from "../../redux/apis/api";

const CreateMarketingMaterials = () => {
  const naviagte = useNavigate();
  const [categoryList, setcategoryList] = useState([]);

  const initialValues = {
    marketing_material_category: "",
    title: "",
    description: "",
    file: [],
    status: "",
  };

  const validationSchema = Yup.object().shape({
    title: Yup.string().required("Required"),
  });

  const handleSubmit = (values) => {
    const finalData = {
      ...values,
      status: values?.status !== "" ? values?.status : "draft",
    };

    api
      .post(`/marketing-materials/create`, finalData)
      .then((response) => {
        successToast(response.message);
        console.log(response, "response");
        naviagte(`/marketing-materials/list`);
      })
      .catch((error) => {
        console.error("API Error:", error);
        errorToast(error?.response?.data?.message);
      });
  };

  const statusOptions = [
    {
      label: "Active",
      value: "active",
    },
    {
      label: "Inactive",
      value: "inactive",
    },
    {
      label: "Draft",
      value: "draft",
    },
  ];

  const fetchCategoryDropDownData = () => {
    api
      .get(`/marketing-materials/category-drop-down`)
      .then((res) => {
        let newArr = res?.data?.data?.categories?.map((ele) => ({
          label: ele.name,
          value: ele.id,
        }));
        setcategoryList(newArr);
      })
      .catch((err) => {
        console.error("API Error:", err);
      });
  };

  useEffect(() => {
    fetchCategoryDropDownData();
  }, []);

  return (
    <MainLayout>
      <section className="h-full overflow-auto px-3">
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
          enableReinitialize={true}
        >
          <Form>
            <div className="flex justify-between items-center mb-5 sticky top-0 bg-background pb-2 z-10">
              <h2 className="text-xl font-semibold capitalize">
                marketing materials - Create
              </h2>
              <div className="flex gap-3 items-center">
                <button
                  onClick={() => naviagte("/marketing-materials/list")}
                  type="button"
                  className="px-4 py-1 border-[2px] border-errorColor text-errorColor rounded"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="px-4 py-1 bg-primary border-[2px] border-primary text-white rounded"
                >
                  Create
                </button>
              </div>
            </div>
            <section className="w-full max-w-[40rem]">
              <div className="my-4">
                <FormTextField
                  name={"title"}
                  label={"title"}
                  placeholder={`Enter title`}
                />
              </div>
              <div className="my-4">
                <FormTextAreaField
                  name={"description"}
                  label={"description"}
                  placeholder={`Enter description`}
                  rows={3}
                />
              </div>
              <div className="my-4">
                <FormDropDown
                  name="marketing_material_category"
                  label="marketing material category"
                  options={categoryList}
                />
              </div>
              <div className="my-4">
                <FormDropDown
                  name="status"
                  label="status"
                  options={statusOptions}
                />
              </div>
              <div className="my-4">
                <FormMultiFileUploadField
                  name={"file"}
                  label={"files"}
                  accept=".pdf,.doc,.docx,.jpg,.png"
                />
              </div>
            </section>
          </Form>
        </Formik>
      </section>
    </MainLayout>
  );
};

export default CreateMarketingMaterials;
